export default "__VITE_ASSET__BgzsVaUD__"